import React from 'react';

// 运费现场结算提示：这单如果是走"第三方物流现场结算"这个模式，delivery_fee会是0，
// 佣金/分店收入里自然也不会包含运费这部分——店员/总店看这块的时候，需要明确知道
// "运费本来就不计入这里"，不是数据缺失或者算错了
const ExternalFeeNotice = () => (
  <p className="text-xs text-amber-600 mt-2 pt-2 border-t border-current/10">
    ⚠️ 本单运费由第三方物流现场结算，不计入以上金额
  </p>
);

const OrderSettlementInfo = ({ order }) => {
  if (order.commission_rate > 0) {
    return (
      <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-sm">
        <p className="font-medium text-blue-700 mb-1">利润分配</p>
        <div className="flex justify-between text-blue-600">
          <span>总店佣金（{(order.commission_rate * 100).toFixed(1)}%）</span>
          <span>${parseFloat(order.commission_amount).toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-green-600">
          <span>分店收入（含配送费）</span>
          <span>${parseFloat(order.branch_amount).toFixed(2)}</span>
        </div>
        {!!order.delivery_fee_external && <ExternalFeeNotice />}
      </div>
    );
  }
  if (order.commission_rate == 0 && order.assigned_store_name) {
    return (
      <div className="bg-green-50 border border-green-100 rounded-lg p-3 text-sm">
        <p className="text-green-700">🏪 总店自行配送，全额收入 ${parseFloat(order.total_amount).toFixed(2)}</p>
        {!!order.delivery_fee_external && <ExternalFeeNotice />}
      </div>
    );
  }
  return null;
};

export default OrderSettlementInfo;